import { Zap } from 'lucide-react'

export const GlobalLoading = () => {
  return (
    <div className="bg-background fixed inset-0 z-[9999]">
      <div className="flex h-full items-center justify-center">
        <div className="text-center">
          <div className="mb-8 flex items-center justify-center gap-2">
            <div className="bg-primary/10 flex h-10 w-10 items-center justify-center rounded-lg">
              <Zap className="text-primary h-6 w-6" fill="currentColor" />
            </div>
            <span className="text-xl font-semibold">Loadline</span>
          </div>
          <div className="flex justify-center gap-1">
            <div className="bg-muted-foreground h-2 w-2 animate-bounce rounded-full [animation-delay:-0.3s]"></div>
            <div className="bg-muted-foreground h-2 w-2 animate-bounce rounded-full [animation-delay:-0.15s]"></div>
            <div className="bg-muted-foreground h-2 w-2 animate-bounce rounded-full"></div>
          </div>
        </div>
      </div>
    </div>
  )
}
